// Day 0 is the moment a campaign is published: the Activation Engine API sets
// the campaign start to the publication time and schedules Touch N at
// publication + N days (stored in UTC). These helpers only present that
// schedule in the viewer's own time zone.

const DAY_MS = 24 * 60 * 60 * 1000;

export const browserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
};

export const sendTimingLabel = (sequenceDay) => {
  const day = Number(sequenceDay) || 0;
  if (day === 0) return "Day 0 · sends when the campaign is published";
  return `Day ${day} · sends ${day} ${day === 1 ? "day" : "days"} after publishing`;
};

export const touchSendTime = (publishedAt, sequenceDay) => {
  if (!publishedAt) return null;
  const start = new Date(publishedAt);
  if (Number.isNaN(start.getTime())) return null;
  return new Date(start.getTime() + (Number(sequenceDay) || 0) * DAY_MS);
};

// dateStyle/timeStyle cannot be combined with timeZoneName (TypeError in
// current browsers), so the date and time parts are listed explicitly.
export const formatSendTime = (date) =>
  date
    ? date.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short",
      })
    : "";
